import React from 'react';
import ProjectionsList from '../components/ProjectionsList';

const PomListPage = () => {
  return <ProjectionsList isPomList={true} />;
};

export default PomListPage; 